import { SOCIAL_PLATFORMS } from '~/constants';
import { LastUpdatedKeysTypes } from '~/types';

type PlatformLastUpdated = {
  [k in SOCIAL_PLATFORMS]: LastUpdatedKeysTypes;
};

export const PLATFORM_UPDATED: PlatformLastUpdated = {
  [SOCIAL_PLATFORMS.tiktok]: 'ttLastUpdatedAt',
  [SOCIAL_PLATFORMS.youtube]: 'ytLastUpdatedAt',
  [SOCIAL_PLATFORMS.instagram]: 'igLastUpdatedAt',
};
export const totalAudience = [
  'igFollowersCount',
  'ttFollowersCount',
  'ytFollowersCount',
];
